<template>
  <header class="header-global">
    <base-nav
      class="navbar-main"
      transparent
      type
      style="background: white"
      expand
    >
      <router-link slot="brand" class="navbar-brand" to="/">
        <img src="/img/brand/optimized/tawitech-logo.png" class="logo" alt="TAWItech Logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="#">
            <img src="/img/brand/optimized/tawitech-logo.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover justify-content-start">
        <li class="nav-item mx-0">
          <router-link
            slot="title"
            to="/asset-tracking-system"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="fa fa-cubes d-lg-none"></i>&nbsp;
            <span class="nav-link-inner--text active"
              >ASSET MANAGEMENT SOLUTIONS</span
            >
          </router-link>
        </li>

        <li class="nav-item mx-0">
          <router-link
            slot="title"
            to="/digital-logging"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="fa fa-calendar d-lg-none"></i>&nbsp;
            <span class="nav-link-inner--text"
              >DIGITAL LOGGING APPLICATION</span
            >
          </router-link>
        </li>

        <li class="nav-item mx-0">
          <router-link
            slot="title"
            to="/it-solutions-hardware"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="fa fa-desktop d-lg-none"></i>&nbsp;
            <span class="nav-link-inner--text">IT SOLUTIONS/HARDWARE</span>
          </router-link>
        </li>

        <li class="nav-item mx-0">
          <router-link
            slot="title"
            to="/security-solutions"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="fa fa-shield d-lg-none"></i>&nbsp;
            <span class="nav-link-inner--text">SECURITY SOLUTIONS</span>
          </router-link>
        </li>
      </ul>
    </base-nav>
  </header>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
};
</script>

<style lang="scss" scoped>
.navbar-main .navbar-nav > li > a {
  color: #343434 !important;
}
.navbar-nav .nav-link #header-links {
  color: #343434 !important;
  font-family: "Poppins" !important;
}
ul {
  margin-left: auto;
  margin-right: 0;
}
.navbar-nav .nav-link {
  color: #050404 !important;
  font-family: "Poppins" !important;
  font-size: 12px;
  font-weight: 600;
}
.header-global {
  position: sticky;
  top: 0;
  z-index: 999;
}

.navbar-main {
  position: relative;
  z-index: 1000;
  text-align: center;
}
@media only screen and (max-width: 986px) and (min-width: 375px) {
  .navbar-main {
  text-align: left;
}
}

</style>